export default {
  // 身份认证模块
  identity: {
    identityCer: '身份认证',
    note: '温馨提示',
    noteDes: '请务必添加被保险人的正确身份信息，否则将无法进行理赔申请。',
    IDtype: '证件类型',
    IDNumber: '证件号',
    IDvaliddate: '证件起始日期',
    validPlace: '请输入证件起始日期',
    IDexpireddate: '证件终止日期',
    expirPlace: '请输入证件终止日期',
    tips: '请选择您的居住所在地，(以使为您推荐更合适的医疗资源)',
    region: '地区选择',
    placePegion: '请选择地区',
    address: '详细地址',
    placeaddress: '请输入详细地址',
    tips1: '起始日期不能大于终止日期',
    tipInfo:
      '温馨提示: 请务必添加被保险人的正确身份信息，否则将无法进行理赔申请。',
    tipArea: '请选择您的居住所在地及相关信息，以便为您推荐更合适的医疗资源。',
    tipTit: '温馨提示',
    tipUserCenter: `您当前保单的身份信息不完整，会影响您的理赔审核。请您在当前页面补充证件照片和个人信息。`
  },
  // progressitem Components
  progressItem: {
    payNum2: '报案编号：',
    payNum: '授权编号：',
    payNum1: '理赔编号：',
    tit: '多案件授权',
    tit1: '多案件理赔',
    serPerson: '保单号/出险人',
    place: '医疗机构',
    date: '就诊日期',
    diagnose: '诊断',
    need: '需要补充',
    material: '上传材料',
    material1: '补充材料',
    cancel: '撤销申请',
    des: '预授权解释',
    materialStatus: '有材料待补充',
    cancleReason: '取消原因：',
    remark: '备注',
    des1: '理赔解释',
    examDate: '审核日期',
    closeTime: '结案时间'
  },
  // commonProgress
  commonProgress: {},
  // login 登录模块
  login: {
    loginTile: '欢迎使用中间带',
    loginSubTitle: '未注册手机号验证后完成注册',
    inputMobile: '请输入手机号(无需输入国家代码)',
    agreed: '我已阅读并同意',
    apa: '自动扣款协议',
    retrievePassword: '忘记密码，去找回',
    codeSignIn: '验证码登录',
    passwordSignIn: '密码登录',
    btn_signin: '登录',
    china: '中国大陆',
    hongKong: '中国香港',
    USA: '美国',
    UK: '英国',
    UAE: '阿联酋',
    inputPassword: '请输入密码',
    errorPhone: '请输入正确手机号',
    inputCode: '请输入验证码',
    errorCode: '请输入正确的验证码',
    agreement: '请确认阅读并同意自动扣款协议',
    inputNewPwd: '请输入新密码',
    confirmNewPwd: '请确认新密码',
    findPassword: '找回密码',
    notSame: '两个密码不一致',
    btn_sendCode: '发送验证码',
    btn_resend: '重新发送 '
  },
  // member模块
  member: {
    viewPersonalInfo: '查看个人信息',
    add: '添加保险卡',
    insuranceBenefits: '保险福利',
    InsuranceCardForFamily: '关联家属的保险卡',
    takeEffect: '生效',
    takeExpire: '失效',
    allPolicy: '全部保单',
    claimApplication: '理赔办理',
    preAuthApplication: '预授权办理',
    medicineForChronic: '线上送药',
    seeDoctor: '医院查询',
    globalNetwork: '环球网络',
    Appointment: '就诊预约',
    bussinessProgressQuery: '业务进度查询',
    pendingDeductible: '待缴自付额',
    messagePush: '消息中心',
    survey: '满意度调查问卷',
    medicalRecordQuery: '就医记录查询',
    otherService: '其他服务',
    contactCustomerService: '联系客服',
    title: '客户满意度调查问卷',
    content:
      '尊敬的客户，<br/>非常感谢您对MediLink中间带的信任和支持，为不断提高我们的服务质量，以便将来为您提供更优质的高端医疗保障和服务，真诚希望您在百忙之中能抽出宝贵时间参与我们的用户满意度调查。我们热切期盼着您的宝贵意见，我们将不胜感激，谢谢！',
    cancel: '取消',
    participate: '去参与',
    qrCode: '就诊时请向医院出示二维码',
    cardPackage: '添加到微信卡包',
    memberCenter: '会员中⼼',
    cardNo: '卡号',
    memberName: '会员姓名',
    companyName: '公司名称',
    memberNo: '会员号',
    effectiveDate: '生效日期',
    customBg: '自定义背景',
    default: '系统默认',
    toUse: '去使用',
    Using: '使用中',
    fontColor: '字体颜色',
    uploadBg: '上传背景图',
    uploadTip: '建议上传1920*1080尺寸的背景图',
    save: '保 存',
    preview: '预 览',
    selectTip: '请选择要删除的卡样',
    inuseDel: '正在使用中，无法删除。',
    changeToUhc: '切换美国保险卡',
    changeToOrigin: '切换原版保险卡',
    front: '正面',
    back: '背面',
    privacyAgreement: '隐私政策',
    perInfo: '个人信息',
    bindSuccess: '保险卡绑定成功'
  },
  // 金牌医生
  doctorAppointment: {
    home: {
      appointDoctor: '预约医生',
      appointTip: '请您关注预约的医生信息',
      appointmentRecords: '服务记录',
      recordTip: '预约状态查询'
    },
    serviceRecord: {
      all: '全部',
      reserved: '已预约',
      cancelled: '已取消',
      time: '时间',
      O: '受理中',
      I: '审核中',
      C: '预约完成',
      L: '预约取消',
      OTip: '预约已提交，正在审核中，请耐心等待',
      ITip: '您的预约已在审核中！',
      CTip: '已成功预约医生，请及时就诊',
      LTip: '预约已取消',
      caseNumber: '编号',
      expectedAppointmentTime: '期望预约时间'
    },
    appointDetail: {
      offices: '科室',
      phone: '联系电话',
      serviceTime: '就诊时间',
      address: '就诊地点',
      office: '就诊门诊',
      info: '就诊人信息',
      name: '姓名',
      appointmentInfo: '预约信息',
      reschedule: '重新预约',
      back: '返回',
      remark: '备注',
      cancel: '取消预约',
      range: '时段',
      selectTime: '请选择时间',
      O: '预约提交时间：',
      I: '审核中时间：',
      C: '预约通过时间：',
      L: '取消时间：'
    },
    appointSelection: {
      searchPlaceholder: '请输入科室或者医生进行搜索',
      allDoctors: '全部医生',
      allOffices: '全部科室'
    },
    doctorList: {
      searchHistory: '历史搜索',
      more: '查看更多',
      appointment: '预约医生',
      advance: '可提前一天预约',
      level: '按照职称筛选',
      doctor: '主任医师',
      associateDoctor: '副主任医师',
      attendingDoctor: '主治医师',
      nodata: '暂无数据',
      offices: '科室',
      hospital: '所在医院',
      phone: '联系电话',
      pt: '时段',
      st: '请选择时间',
      to: '至',
      cancle: '取消',
      confirm: '确认'
    },
    doctorDetail: {
      introduction: '医生名片',
      hospital: '所在医院',
      phone: '联系电话',
      experience: '医生资质',
      specialty: '擅长领域',
      making: '预约确认',
      date: '期望预约日期',
      select: '请选择',
      time: '期望预约时间',
      info: '就诊人信息',
      notice: '预约须知',
      process:
        '预约方式：本门诊部采取就诊人实名制预约，需要您如实提供就诊人真实姓名、有效证件号码、性别、年龄、手机号码等信息，以便完成预约。',
      succeeded:
        '预约成功：您会收到预约成功消息提示，也可在服务进度中查询预约状态。',
      modification:
        '修改/取消预约：如预约时间有变，在订单页选择 [取消预约] 即可取消订单重新预约（建议24小时之内操作取消）。',
      access:
        '金牌医生独享快速预约通道，最晚次日确认就诊时间，最快可预约当天号源，保证7天内完成就诊。',
      schedule: '医生排班是医生在该医院坐诊的时间供参考。',
      toast: '请完善就诊信息',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      onHospital: '就诊医院'
    }
  },
  // 线上问诊
  consultService: {
    healthConsultation: '健康咨询',
    healthConsultationDesc: '提供健康管理咨询（不可送药），家人均可使用',
    onlineConsultation: '在线问诊',
    onlineConsultationDesc: '提供三甲医生问诊服务，问诊送药闭环服务',
    videoDoctor: '视频医生',
    videoDoctorDesc: '和医生面对面高效问诊',
    onlinePharmacyDelivery: '线上送药',
    onlinePharmacyDeliveryDesc: '提供凭处方送药服务，有半年内处方笺可申请'
  },
  // 线上送药
  onLinePharmacyDelivery: {
    title: '线上送药',
    apply: '送药申请',
    know: '请您关注送药服务须知',
    progress: '进度查询',
    check: '授理送药案件进度、申请列表查看',
    policy: '选择保单',
    choose: '请您选择对应的保单',
    des: '本服务仅适用于含线上送药服务的产品。如果您需要使用该服务，为确保能及时将药物送达，请至少提前一周告知我们',
    number: '保单号',
    insured: '出险人',
    Membership: '保险卡号',
    year: '保险有效期',
    phone: '联系电话',
    mail: '联系邮箱',
    next: '下一步',
    notice: '服务须知',
    readtit: '请您仔细阅读以下信息',
    readone:
      '1、“给您送药的药房是具有国家资质的品牌药房，不属于中间带，但是中间带会定期审核其服务质量以及从业人员资质。”申请线上送药服务时，我们会将您的申请材料，包括但不限于个人基本信息、病历、处方等交给中间带的合作药房互联网医疗机构。',
    readtwo:
      '2、线上送药服务仅提供真实有效就诊后所需的药物配送服务。服务内容∶仅限于OTC和双轨制处方药。单轨制处方药（精神类、抗生素、胰岛素、生物制剂、安眠药、麻醉类药物等）除外。',
    readthree:
      '3、为了您的用药安全，我们建议：若为慢性病送药申请，您需已服用现有药物3个月以上，病情稳定，不需要调整药物或药物的用法、用量的情况下再选用该项服务。若为普通疾病送药申请，请确认之前有用药记录且服药后无不良反应。服药期间如有不适，请及时就医。',
    readfour:
      '4、药房直付服务根据您的有效医疗文件，慢性病送药申请最多提供90天的药物量，普通疾病送药申请药量以医嘱为准。后续如您仍需线上送药服务，请到正规医院复诊，并提供最新的病历及处方（药物用法，用量）。',
    readfive:
      '5、在诊断相同的情况下，在所申请药量根据处方笺及医嘱用完前，您通过其他购药途径（包括但不限于医疗机构，药房等）购买的该药品所产生的理赔可能会被拒赔。',
    readsix:
      '6、若因不可抗力（如疫情政策、互联网医疗相关政策变动等情况）导致部分药品无法配送，中间带保留最终解释权。',
    understood: '我已完全理解和接受药房直付服务的相关内容和规定',
    upload: '上传资料 ',
    materials: '请您上传相关材料',
    updes:
      '药房直付服务根据您的有效医疗文件，慢性病送药申请最多提供90天的药物量，普通疾病送药申请药量以医嘱为准。后续如您仍需在线送药服务，请到正规医院复诊，并提供最新的病历及处方（药物用法，用量）',
    names: '药品名称',
    dosage: '用量',
    cancel: '取消',
    ok: '确定',
    select: '请选择（建议拿取一个月药量）',
    fiveDays: '5天',
    weeks: '2周',
    onemonth: '1个月',
    twomonth: '2个月',
    threemonth: '3个月',
    other: '其他',
    usage: '药物处方单（药物用法、用量、药品包装）',
    record: '病历（一年内）',
    id: '身份证件',
    mailinfo: '邮寄信息',
    mailinginfo: '请填写邮寄信息',
    maildes:
      '如果您需要我们提供该服务，为确保能及时将药物送达，请至少提前一周告知我们',
    consignee: '收货人',
    tel: '联系电话',
    address: '收货地址',
    city: '城市/区域',
    addressdetail: '详细地址（例如：**街**号**）',
    door: '门牌号',
    save: '是否保存该地址',
    expected: '期望收货时间',
    remark: '备注',
    remarkdes:
      '如您有其他需求，请填写在此处（非必填，最多输入80个汉字或160个字符）',
    sign: '电子签名',
    confirm: '请确认填写信息是否正确',
    signature: '根据电子签名，自动生成的《线上送药服务理赔申请书》',
    modify: '修改',
    complete: '完成',
    back: '返回',
    all: '全部',
    submitted: '已提交',
    processing: '服务中',
    completed: '已完成',
    invalid: '无效申请',
    process: '审核中',
    approved: '审核通过',
    rejected: '审核未通过',
    canceled: '已取消"',
    time: '时间',
    pt: '时段',
    st: '请选择时间',
    to: '至',
    case: '编号',
    detail: '详情',
    nodata: '暂无数据',
    sb: '提交申请',
    citypicker: '地区选择',
    emptycity: '请先选择城市/区域',
    emptyname: '请输入收货人姓名',
    emptyphone: '请输入收货人联系电话',
    emptyrecivedarea: '请选择收货城市/区域',
    emptyaddress: '请选择收货地址',
    emptynumber: '请输入门牌号',
    subsuccess: '您的申请已提交！',
    saveerr: '保存失败',
    policyNo: '请选择保单',
    enternumber: '请输入联系电话',
    enteremail: '请输入联系邮箱',
    aftersign: '请签名后点完成按钮！',
    read: '请阅读并勾选药房直付服务的相关内容和规定',
    signatureBtn: '请签名',
    datePlaceHolder: '请选择日期',
    remove: '重置',
    btnConfirm: '确认',
    signatureConfirm: `请确保您的电子签名清晰、完整，此签名视为您对本次理赔申请的确认。您的签名将展示在《事后理赔申请单》中的患者签名部分。若就诊人为未成年人，由申请人签字。`,
    trackingNo: '快递单号',
    confirmReceipt: '确认签收',
    receiptsuccess: '签收成功！',
    confirmInfo: '确认信息'
  },
  // 全部保单
  allPolicy: {
    backTime: '退保日期',
    effective: '有效保单',
    effectiveCard: '有效保险卡',
    history: '历史保单',
    historyCard: '历史保险卡',
    placeHolder: '输入保险卡号',
    serNum: '保单号',
    serPerson: '主被保险人',
    serCard: '保险卡号',
    serPerson1: '连带被保人',
    serDate: '保险有效期',
    bx: '保险福利',
    policyM: '保单管理',
    cardM: '选择保险卡'
  },
  // 医院查询
  queryhospital: {
    all: '全部',
    area: '全部地区',
    plan: '全部产品',
    property: '性质',
    class: '类别',
    level: '等级',
    placeHolder: '请输入医院名称',
    hProperty: '医院性质',
    hClass: '医院类别',
    nearby: '当前',
    locFail: '定位失败，点击重新定位',
    toastLocFail: '定位失败！请确认您的微信定位是否开启',
    locSuc: '定位成功',
    prompt: '中间带想访问您当前的位置',
    btn1: '不允许',
    btn2: '好',
    yuyue: '预约',
    nodatap: '暂无医院资源噢',
    hospitalQuery: '医疗机构查询',
    Y: '是',
    N: '全部',
    fullhours: '24小时',
    emergency: '急诊',
    to: '至',
    propertyOptions: {
      all: '全部',
      p1: '民营',
      p2: '公立',
      p3: '外资'
    },
    hospitalDetail: {
      tit: '医院详情',
      serviceTit: '服务满意度',
      des: '简介',
      yuyuebtnhos: '预约',
      back: '返回',
      tab: {
        des: '医院介绍',
        service: '相关服务'
      },
      tabcon1: {
        hospitalProperty: '医院性质',
        fullhours: '24小时',
        emergency: '急诊',
        hospitalClass: '医院类别',
        specificClass: '专科类别',
        top100: '百强科室',
        openTime: '开放时间',
        docPrompt: '就医提示',
        stationaryService: '驻点服务',
        stationaryWorkTime: '驻点工作时间'
      },
      tabcon2: {
        question1: '如何到达直付就医部门？',
        question2: '特色科室',
        question3: '住院服务',
        question4: '直付就医流程',
        question5: '就医体验',
        question6: '其他科室'
      },
      lookAll: '查看全部科室',
      map: '医院地址',
      to: '至',
      stopInfo: {
        title: '停车信息',
        reservedPark: '可预留车位',
        onParkReserved: '不可预留车位',
        fee: '停车收费：',
        where: '停车位置：',
        tips: '温馨提示：'
      }
    },
    hospitalSearch: {
      search: '搜索',
      searchHistory: '搜索历史',
      placeHolder: '请输入医院名称'
    }
  },
  // 预约
  hospitalappointment: {
    isMajorIllness: '是否重疾：',
    Appointmentingtab: '预约中',
    Appointmentendtab: '已完成',
    orderNo: '预约单号：',
    appointdocdep: '预约科室和医生：',
    dateandtime: '期待就诊日期和时间：',
    empName: '就诊人：',
    cancelyy: '取消预约',
    againYY: '再次预约',
    P: '处理中',
    I: '处理中',
    O: '受理中',
    C: '预约完成',
    L: '预约取消',
    F: '预约失败',
    yuyuebtn: '预约',
    yuyuebtnhos: '预约',
    back: '返回',
    baoxianNo: '保险卡：',
    Contact: '联系方式：',
    Languageofvisit: '就诊语言：',
    institutions: '医疗机构：',
    address: '地址：',
    Telephone: '电话：',
    Department: '科室：',
    Doctor: '医生：',
    date: '预约日期：',
    time: '预约时间：',
    ramker: '备注：',
    writeOrder: '填写预约单',
    submitOrder: '提交预约信息',
    placecardno: '请选择保险卡号',
    placeempName: '请填写就诊人的姓名',
    placehpno: '请填写就诊人的联系方式',
    placeproviderName: '请选择医疗机构',
    placeaddress: '由医疗机构自动带出',
    placephone: '由医疗机构自动带出',
    placedepartment: '请填写期望预约科室(非必填)',
    placedoctor: '请填写期望预约医生(非必填)',
    placedate: '请选择期望预约日期',
    placetime: '请选择期望预约时间',
    placeMarker:
      '如有备选医院、备选科室、备选医生、备选日期和时间，可填写在此处（非必填，最多输入80个汉字，160个字符）',
    applySuccess: '提交成功，请至就诊预约查看预约信息！',
    quxiaoSuccess: '取消预约成功！',
    addnews: '请填写完整信息',
    nologin: '您还没有登录！',
    yuyueOn: '预约该医疗机构',
    yuyuejigou: '预约机构：',
    querencancel: '请您确认是否取消该预约？',
    queding: '确定',
    cancel: '取消',
    tipYuyue: '医疗机构列表与就诊人不匹配，保险卡已自动更换。',
    selectlan: '语言',
    selectDate: '日期',
    selectTime: '时间',
    nodata: '暂无预约记录噢',
    symptom: '症状：',
    placesymptom: '请输入您的症状（必填，最多输入80个汉字，160个字符）',
    healthInfo1:
      '接触史：就诊人和陪同者健康码中健康状态是否为“未见异常（绿色）”？近期是否有中高风险境外、境内旅居史？近期是否接触过疑似新冠病毒感染者？',
    healthInfo2:
      '疑似症状：就诊人3日内是否体温≥37.3℃（明确疾病导致长期发热除外）或存在干咳、咽痛、咯痰、嗅觉味觉减退等疑似症状？',
    healthInfoFlag1: '是',
    healthInfoFlag2: '否',
    des1: '补充信息',
    des2: '请简要说明相关情况',
    prompt: '该医疗机构暂不支持周六周日预约，请重新选择日期',
    dateTitle: '预约日期',
    againtitle: '再次预约',
    eduittitle: '填写预约单',
    title: '预约单详情',
    dateTip: '注：如需预约当日就诊，请拨打400-114-9606咨询当日号源'
  },
  // 就医体验
  medicalevaluation: {
    hospitalJudge: '就医评价',
    tit: '服务满意度',
    placeHolder: '谈谈您的就医感受吧，限200字',
    submit: '匿名提交',
    submitBtn: '提交就医体验',
    nomore: '没有更多了哦'
  },
  // 查询就诊记录
  serverdInstitutionSearch: {
    consultantInfo: '咨询人信息',
    guidance: '指导意见',
    videoDoctor: '视频医生',
    consultationSummary: '咨询总结',
    consultationTime: '咨询时间',
    consultant: '咨询人',
    consultantNo: '咨询单号',
    finished: '已完成',
    inProgress: '诊断中',
    processing: '进行中',
    claimNo: '理赔编号',
    closeCase: '已结案',
    selfClaim: '自助理赔',
    hProperty: '医院性质',
    hClass: '医院类别',
    practice: '就医体验',
    ViewMedicalExperience: '查看就医体验',
    date: '就诊日期',
    patient: '就诊人',
    diagnose: '诊断',
    tips: '以上结论根据用户描述提供建议，仅供参考，如症状不缓解、加重或出现其他不适，请及时至医院就诊，感谢您的使用。'
  },
  // 理赔进度查询
  claimQuery: {
    promptTit: '温馨提示',
    prompt11: '撤销后，您将无法再编辑该案件',
    prompt21: '确定撤销吗？',
    promptBtnCancel: '取消',
    promptBtn1: '确认撤销',
    prompt1: '删除后，您将无法再编辑该案件',
    prompt2: '确定删除吗？',
    promptBtn: '确认删除',
    all: '全部',
    wait: '已撤销',
    mid: '审核中',
    have: '已结案',
    time: '时间',
    date: '就诊日期',
    paymentQuery: '自助理赔进度查询',
    nodatap1: '没有查到相关内容噢',
    timeOption: {
      all: '全部',
      year: '一年',
      halfYear: '半年',
      month: '三个月'
    },
    noReduceTip: '该笔理赔仅扣除保障额度，不计入门诊理赔次数。'
  },
  // 理赔解释
  claimExplain: {
    claimInfoTit: '理赔信息',
    claimNo: '理赔编号',
    policyNo: '保单号',
    claimant: '被保险人',
    cardNo: '会员卡号',
    hospital: '医院',
    diagnosis: '诊断',
    admissionDate: '入院日期',
    dischargeDate: '出院日期',
    icuDays: '特护天数',
    days: '住院天数',
    chargeDetailsTit: '费用明细',
    description: '描述',
    policyLimit: '保单额度',
    amtIncurred: '应付(CNY)',
    amtApproved: '批准(CNY)',
    amtToPay: '不批准(CNY)',
    total: '总计',
    remarks: '理赔结论'
  },
  messageAbout: {
    messagePush: '消息中心',
    noContentYet: '暂无内容',
    noNews: '暂无消息',
    messageCenter: '消息中心',
    myMessage: '我的消息',
    messageNotice: '消息通知',
    promotions: '优惠活动',
    readAll: '全部已读',
    all: '全部',
    read: '已读',
    notRead: '未读',
    clear: '清空',
    othersService: '其他服务',
    feedback: '意见反馈',
    registerDate: '注册日期',
    signOut: '退出登录',
    confirmCallTel: '确定拨打电话：'
  },
  //
  memberAbout: {
    messagePush: '消息中心',
    membersCentre: '会员中心',
    notification: '消息通知',
    contactUs: '联系我们',
    personalQRCode: '个人二维码',
    longPressSaveQR: '长按保存二维码',
    idNumberActivation: '证件号码激活',
    healthCardActivation: '健康卡激活',
    activateMedicalServices: '激活医疗服务',
    changesInClaimsAccount: '赔款账户变更',
    accountManagement: '账号管理',
    langSetting: '语言设置',
    feedback: '意见反馈',
    commonProblem: '常见问题',
    realname: '真实姓名',
    changePhoneNumber: '变更手机号',
    loginPassword: '登录密码',
    changeLoginPassword: '修改登录密码',
    processingStatus: '会员中心',
    dischargeSummary: '出院小结',
    brithCertify: '出生证明',
    welfareDesc: '福利描述',
    welfareLimit: '福利限制',
    condition: '条件',
    allowance: '剩余',
    shareNum: '共享额度',
    shareTimes: '共享次数',
    shareSeeTxt1: '保单额度共享福利查看',
    shareSeeTxt2: '保单次数共享福利查看',
    responsiby: '责任',
    welfare: '福利',
    consume: '消耗',
    welfareDetail: '福利详情',
    welfareLimitTxt1: '共享年度限额',
    welfareLimitTxt2: '共享年度次数',
    welfareLimitTxt3: '以下福利共享年度限额',
    welfareLimitTxt4: '以下福利共享年度限制',
    welfareLimitTxt5: '累计消耗',
    moneyUnit: '元',
    time: '次',
    warningReminder: '福利快使用完了！'
  },
  // 自助理赔
  claim: {
    claimApply: {
      saveTips: '您的数据将保存至今日24:00',
      help: '什么是自助理赔？',
      viewDetail: '查看详情',
      policy: '选择保单',
      upload: '上传材料',
      notice: '理赔须知',
      done: '完成',
      writeApply: '填写申请',
      nextStep: '下一步',
      knowNotice: '提交申请前, 请您注意以下事项！',
      notification: '反保险欺诈协议',
      statement: '理赔申请确认条款',
      readAgreed: '我已阅读并同意',
      know: '知道了',
      antiFraudClause: `
        <p>诚信是保险合同基本原则，涉嫌保险诈骗将承担以下责任：</p>
        <p>【刑事责任】进行保险诈骗犯罪活动，可能会受到拘役、有期徒刑，并处罚金或没收财产的刑事处罚，保险事故的鉴定人、证明人故意提供虚假的证明文件，为他人犯罪提供条件的，以保险诈骗罪的共犯论处</p>
        <p>【行政责任】进行保险诈骗活动，尚不构成犯罪的，可能会受到15日以下的拘留、5000元以下罚款的行政处罚；保险事故的鉴定人、证明人故意提供虚假的证明文件，为他人诈骗提供条件的，也会受到相应行政处罚。</p>
        <p>【民事责任】故意或因重大过失未履行如实告知义务，保险公司不承担赔偿或给付保险金的责任</p>
        `,
      claimApplyConfrim: `
        <p>我同意，在任何情况下，保险保障所不包含的医疗费用及服务等将由我本人足额支付。我同意由保险公司或者中间带直接联系我并通过银行转账的方式收取。如果我不能按时支付，我将承担由此产生的额外费用，包括合理的法律诉讼费用、保险公司、中间带或医疗机构向我收取此费用过程所产生的其他费用等。</p>
        <p>我同意因理赔或相关服务需要，保险公司、医疗机构及中间带可以分享与我本人有关的保险福利、健康、医疗信息及资料。我同意任何医生、医疗机构、药剂师、保险公司、雇主、工会或协会将我就诊治疗、接受护理的相关病历、病史等资料信息（包括复印件）提供给中间带。我同意因理赔或相关服务需要，由保险公司或者中间带代我处理理赔款。我在此确认以上声明和授权真实完整，我本人愿意进一步提供其他所需信息。</p>
        <p>对于发生在事先约定的医疗机构内，针对特定的或本保险人已经事先担保的医疗项目，本人在此授权该医疗机构或预先指定的第三方代表本人向保险人索赔，保险人应该直接支付给该医疗机构或指定的第三方。</p>
        <p>以上授权的复印件与原件视为同等效力。</p>
        `,
      notice1:
        '同一就诊理赔请勿重复提交，同一天同一医疗机构同一疾病视为一次理赔',
      notice2:
        '自助理赔允许您提交{amount}人民币(含)以下的理赔申请，{amount}人民币以上事后理赔案件需通过线下提交，理赔资料寄送地址请查阅《保险服务手册》',
      notice3:
        '为了保证您在尽可能短的时间内收到理赔款，请按银行名称+所在市+支行名称的规则填写开户银行（示例：招商银行广州市花城支行）',
      notice4:
        '为了保证尽快收到理赔款，请提前确认好出险人姓名，并提交至正确的出险人名下进行申请理赔',
      notice5:
        '自助理赔是指传统的报销模式，被保险人在就诊时全额向医疗机构支付医疗费用，随后持发票、病例、检查报告、申请表等资料再向保险公司或保险公司授权的第三方机构提出报销申请。',
      policyNo: '保单号',
      policyPeople: '就诊人',
      effectInsureTime: '保险有效期',
      surrenderTime: '退保日期',
      applayer: '申请人',
      applayerHolder: '请输入申请人',
      relationWithInsured: '与就诊人关系',
      chooseRelation: '请选择与就诊人关系',
      medicalLocation: '医疗机构所在地',
      medicalLocationHolder: '请选择医疗机构所在地', // 请选择医疗机构所在地
      medicalInstitution: '医疗机构',
      medicalHolder: '请输入医疗机构名称',
      preDoctorTime: '就诊日期',
      seeDoctorHolder: '请选择就诊日期',
      treatmentType: '就诊类型',
      poliyDutyHolder2: '请选择就诊类型',
      applyMoney: '申请金额',
      moneyAccount: '汇款账户',
      claimAccount: '理赔款账户',
      claimAccountP: '请选择理赔款账户',
      moneyHolder: '请填写金额',
      bankaccnm: '户名',
      openCardBK: '开户行', // 开户行
      note: '温馨提示',
      tips: '成年用户请选择自己的银行卡接收理赔款，未成年用户可使用他人银行卡接收</br>理赔款账户币种需要与理赔申请的币种一致',
      placeHolder2: '请输入您对理赔的其它诉求（125字）',
      update_tip: '为了顺利通过审核 请提供以下材料 有圆点类别为必传项',
      example: '示例',
      yes: '是',
      no: '否',
      tipsTitle: '温馨提示',
      changePolicyTips: '若重新选择保单号，将清空您已填写的信息，请谨慎选择！',
      kindReminding:
        '温馨提示：如非本人就医的理赔申请，请在下方“保单号”处选择就诊人的对应的保单信息。',
      back: '上一步',
      require: '-上传要求',
      sampleTip: '下图为示例说明，要求拍摄文字清晰',
      signPreview: '电子签名预览'
    }
  },
  preAuthApply: {
    help: '什么是预授权？',
    viewDetail: '查看详情',
    notice1:
      '1、无论是直接付费服务，还是事后理赔，对特定的医疗治疗项目，保险公司均需要您事先获得授权批准，否则可能导致您额外花费了部分非合理且必需的费用而无法在保险保障范围内得到赔偿。甚至，应授权而未授权的案例会造成理赔金额的降级赔付。',
    notice2:
      '2、常见需申请预授权的医疗项目: 所有住院医疗保障； 复杂牙科治疗；门诊肿瘤放化疗治疗； 全麻下的门诊手术； 家庭护理；羊水穿刺检查（35岁以下的孕妇）； 购买拐杖、轮椅和助走器；加强CT/立体定向放射治疗装置（指伽马刀）；其他保险计划中约定需预先批准的医疗项目。',
    notice3:
      '3、您应在接受上述特定治疗项目前通知医院向中间带提交事先授权申请表，以便中间带客户联络中心在您预定开始治疗日期前至少3个工作日收到该申请表。中间带及您的保险公司将自收到该完整填写的申请表后的48小时内予以书面回复。若您的医疗费用过高或住院天数过长，中间带及您的保险公司可能需要更长的时间来进行审核，一般情况下将在5个工作日内给予答复。另外，出于授权审核的需要如批复过程中需要补充您其它的诊疗资料，还请您和你的主治医生协助提供，以便尽早完成授权审核。',
    sickInfo: '病人信息',
    upload: '上传材料',
    done: '完成'
  },
  // 在线问诊
  chooseBaodan: {
    policyNo: '保单号',
    insured: '就诊人',
    effectInsureTime: '保险有效期',
    nextStep: '下一步'
  },
  // 以上已整理
  title: {
    home: '首页',
    message: '脱壳咨询',
    fundFlow: '资金流向',
    focus: '脱壳关注',
    quote: '成交排行',
    chain: '链上数据',
    community: '社群数据',
    code: '技术评估',
    claimApply: '理赔申请',
    claimsBusiness: '理赔业务办理',
    preAuth: '预授权办理',
    preAuthApply: '预授权申请',
    preAuthDetail: '预授权详情',
    insureDuty: '保险责任',
    welfare: '保险福利',
    bankCard: '银行卡管理',
    addBCard: '添加银行卡',
    addB: '选择银行',
    addC: '城市选择',
    verifyTitle: '修改',
    basicInfo: '基本信息',
    policyInfo: '保单信息',
    material: '投保材料'
  },
  advice: {
    title: '请选择您遇到的问题类型或建议类型',
    claimServices: '理赔服务',
    optSuggestion: '优化建议',
    complaints: '投诉',
    others: '其他',
    comments: '用的不爽、就来吐槽吧～',
    addPictures: '添加图片',
    pictureLimit: '（您最多可以添加3张图片）',
    fillInfo: '填写信息',
    username: '你的姓名',
    fillUserName: '请输入您的姓名',
    yourGender: '您的性别',
    Male: '男士',
    Female: '女士',
    mobile: '手机号码',
    contacts: '请输入您的联系方式',
    feedback: '意见反馈'
  },
  userCenter: {
    info: '个人信息',
    modify: '去修改',
    upload: '去上传',
    IDPhoto: '证件照片',
    male: '男',
    female: '女',
    upload1: '已上传',
    noC: '未完善',
    unDate: '已过期，重新上传',
    address: '地址',
    uploadAgain: '重新上传'
  },
  updateUserInfo: {
    updateQuery: '信息确认',
    updateEdit: '信息 变更',
    tipsTextOne:
      '为了保护您个人健康信息隐私和重要理赔信息通知；烦请再次核实以下您的联系方式和邮箱地址。',
    tipsTextTwo: '如果您的信息发生了变更，请输入正确信息',
    phone: '手机号',
    email: '邮  箱',
    tipEmailEpy: '邮箱不能为空',
    tipEmailErr: '邮箱格式不正确',
    tipPhoneEpy: '手机号不能为空',
    tipSuccess: '信息变更成功',
    btnConfirm: '确认',
    btnModify: '修改',
    btnSubmit: '保存',
    btnCancle: '取消'
  },
  other: {
    othersService: '其他服务'
  },
  userAbout: {
    firstName: '名',
    lastName: '姓',
    name: '姓名',
    gender: '性别',
    birthDate: '出生日期',
    nationality: '国籍',
    idType: '证件类型',
    idNumber: '证件号码',
    idCardValidity: '证件有效期',
    professionalCateory: '职业类别',
    phoneNumber: '手机号',
    detailedAddress: '详细地址',
    placeholder_detailedAddress:
      '请输入详细地址，如：街道、门牌号、小区、楼栋号、单元室等。',
    email: '电子邮箱',
    address: '地址',
    unfinished: '地址填写',
    toModify: '去修改',
    inputName: '请输入真实姓名',
    inputCardNumber: '请输入证件号',
    inputNewPwd: '请输入新密码',
    idCard: '身份证',
    passport: '护照',
    MTP: '台胞证',
    HMPasser: '港澳通行证',
    brithCertify: '出生证',
    forgetPassword: '忘记密码？',
    cannotReceiveCode: '收不到验证码?',
    idCardAuth: '身份验证',
    placeholder_idCardValidity: '请选择证件有效期',
    confirmPhone: '请确认您的手机号：',
    longTerm: '长期',
    btn_Inquiry: '查询',
    uploadIdCard: '拍摄/上传您的二代身份证',
    uploadPassport: '拍摄/上传您的护照',
    note: '温馨提示',
    idCardHint:
      '请务必添加持卡⼈（被保险⼈）的正确身份信息，以⾄后续您的绑卡校验，当您绑定保险卡后，将⽆法更换身份信息。',
    idCardHint1:
      '为了您的案件快速审核通过，请拍照/上传您的二代身份证，信息仅用于身份验证，中间带保障您的信息安全。',
    idCardHint2: '下拉即可选择您需要添加的证件类型',
    veriInformation: '信息仅用于身份验证，中间带保障您的信息安全',
    veriInformation1:
      '其他类型包含港澳台居⺠身份证等，请⾄少上传⼀张图⽚。信息仅⽤于身份验证，中间带保障您的信息安全。',
    placeholder_occupation: '请输入您的职业',
    placeholder_email: '请输入您的电子邮箱',
    others: '其他',
    male: '男',
    female: '女',
    shortTime: '短期有效',
    longTime: '长期有效',
    idCardStart: '证件开始时间',
    idCardEnd: '证件截止时间',
    areaPlaceholder: '请选择地区',
    addressPlaceholder: '(非必填)请输入详细地址',
    emailPlaceholder: '(非必填)请输入电子邮箱',
    placeInput: '请输入',
    startTime: '开始日期',
    endTime: '截止日期'
  },
  accountAbout: {
    changePhone: '请您输入要绑定的手机号',
    enterUserName: '请输入用户名'
  },
  tips: {
    cancleBtn: '取消',
    confirmBtn: '确认',
    changePhoneNumber: '请输入要绑定的手机号',
    inputPlaceHolder: '请输入内容',
    selectIdType: '请选择证件类型',
    enterIdNumber: '请输入证件号码',
    enterMobileNumber: '请输入手机号',
    enterEmail: '请输入邮箱(非必填)',
    genderPlaceHolder: '请选择性别',
    datePlaceHolder: '请选择时间',
    phoneTips:
      '当前手机号与您投保时预留的手机号不一致，请联系客服人员为您在系统中修改，帮助您完成绑卡。'
  },
  text: {
    systemMessage: '系统消息',
    bussinessMessage: '业务消息',
    chinese: '中文',
    english: '英文',
    Y: '是',
    N: '全部',
    nodatap1: '没有查到相关内容噢',
    insuranceCard: {
      inputCard: '请输入8000开头的保险卡号',
      inputPassword: '请输入密码(初始密码为证件后六位)',
      password: '请输入保险卡密码',
      addFailed: '操作失败？',
      mobileBind: '手机快速绑定',
      btn_bind: '绑定保险卡',
      invalid_bind_hint:
        '查询到您的个人信息与该保险卡投保人/被保人信息不符，请尝试其他绑定保险卡的方法,您也可以通过公众号联系客服。',
      phone_not_found:
        '未查询到对应的手机号码，请尝试其他绑定保险卡的方法。您也可以通过公众号联系客服。',
      password_bind: '保险卡密码绑定',
      mainTit: '主被保险人保险卡',
      subTit: '连带被保险人保险卡',
      show: '展开',
      hide: '收起',
      manage: '管理',
      effect: '生效',
      expire: '失效',
      add1: '添加连带被保险人保险卡',
      prompt1: '您可对保险卡',
      prompt2: '进行操作',
      promptTit: '温馨提示',
      prompt3:
        '解除绑定后，我们将无法为您提供在线理赔申请、直付医疗网络查询、理赔进度提醒等各项服务，确定解除绑定吗？',
      promptBtn: '解除绑定',
      promptBtnCancel: '取消',
      add: '添加保险卡',
      forgetPassword: '忘记密码？',
      quicklyBind: '证件号手机号快速绑定',
      quicklyBindByCard: '保险卡快速绑定',
      forgetTip:
        '保险卡初始密码为您投保时预留的证件号后6位，若您忘记密码或需重置密码请联系客服为您处理<a href="tel:4001149606" class="add-card-tel">4001149606</a>。'
    },
    ownExpense: {
      waitPay: '待付保单',
      havePay: '已付保单',
      class: '类别',
      level: '等级',
      all: '全部',
      serNum: '保单号',
      serNum1: '理赔编号',
      serPerson: '保险卡/出险人',
      place: '医疗机构',
      date: '就诊日期',
      diagnose: '诊断',
      money: '待缴自付金额',
      moneypaid: '实付款',
      opinion: '意见评估',
      allSelected: '全选',
      count: '合计',
      goPay: '去支付',
      placeHolder: '输入保险卡号',
      waitpay: '待支付',
      havepay: '已支付'
    },
    BXCardStatus: {
      dealing: '处理中',
      noPassed: '审核不通过',
      done: '已完成',
      supplementaryMaterials: '待补充材料'
    },
    ownExpenseDetail: {
      tit: '多案件授权',
      tit1: '多案件理赔',
      serNum: '保单号',
      serNum1: '理赔编号',
      pay: '直付',
      havePay: '已支付',
      serCard: '保险卡号',
      serPerson: '出险人',
      serDate: '保险有效期',
      cardDate: '证件有效期',
      place: '医疗机构',
      date: '就诊日期',
      diagnose: '诊断',
      InsuranceDuty: '保险责任',
      totalMoney: '总金额',
      payMoney: '赔付金额',
      personMoney: '自付金额',
      waitPay: '待缴自付金额',
      serStatus: '理赔状态',
      opinion: '评估意见',
      goPay: '去支付',
      policyStatus: '保单状态'
    },
    paymentProgressQuery: {
      all: '全部',
      wait: '已撤销',
      mid: '审核中',
      have: '已结案',
      have1: '审核完成',
      time: '时间',
      promptTit: '温馨提示',
      prompt1: '删除后，您将无法再编辑该案件',
      prompt2: '确定删除吗？',
      promptBtn: '确认删除',
      prompt11: '撤销后，您将无法再编辑该案件',
      prompt21: '确定撤销吗？',
      promptBtn1: '确认撤销',
      promptBtnCancel: '取消',
      payNum: '授权编号',
      payNum1: '理赔编号',
      payNum2: '报案编号：',
      pre: '预授权',
      walfare: '福利',
      haved: '事后',
      pay: '直付',
      serPerson: '保单号/出险人',
      place: '医疗机构',
      need: '需要补充',
      reason: '查看原因',
      edit: '修改申请',
      delete: '删除申请',
      change: '变更账户',
      material: '上传材料',
      material1: '补充材料',
      cancel: '撤销申请',
      des: '预授权解释',
      date: '就诊日期',
      des1: '理赔解释',
      result: '本次理赔正常赔付',
      reasonDes: '不通过原因',
      materialStatus: '有材料待补充'
    },
    fileDownload: {
      tit: '您可以选择以下材料下载（可多选）：',
      placeHolder: '请填写您的邮箱用于接收附件',
      email: '发送至邮箱'
    },
    commonQuestion: {
      question1: '理赔常见问题',
      question2: '预授权常见问题',
      question3: '预约相关常见问题',
      question4: '服务流程常见问题',
      question5: '契约常见问题',
      question6: '其他常见问题'
    },
    incrementService: {
      familyDoc: '家庭医生',
      consult: '线上问诊咨询',
      appoint: '预约医生',
      moreService: '更多服务咨询',
      examinationAppoint: '体检预约',
      healthConsultation: '健康咨询',
      onlineConsultation: '在线问诊',
      videoDoctor: '视频医生',
      onlinePharmacyDelivery: '线上送药'
    },
    sumittedMat: '已提交的材料',
    nodatap: '暂无医院资源噢',
    contactUs: {
      tit1: '在线咨询',
      titDes1: '24小时在线客服为您服务',
      tit2: '电话咨询',
      titDes2: '400-880-8820',
      titDes3: '人工客服09:00~18:00在线',
      tit3: '在线联系'
    },
    networkHospital: {
      tit1: '新增网络医院',
      des1: '本月中间带合作网络医院名单',
      tit2: '网络医院动态',
      des2: '十一长假又到了！下面是长假期间部分中间带网络医疗机构的放假安排，各位会员就诊前可以留意一下~',
      des3: '2020部分地区医院劳动节放假安排地区示意目录',
      des4: '中秋&国庆假期|中间带部分网络医疗机构放假安排',
      des5: '2020年中间带部分网络医疗机构端午假期放假安排',
      des6: '2021年元旦，中间带部分网络医疗机构放假安排。'
    },
    supplyMaterial: {
      tit: '为了顺利通过审核 请提供以下材料',
      des: '备注',
      placeHolder: '请输入您对理赔的其它诉求（125字）',
      btn: '提交'
    },
    time: {
      all: '全部',
      year: '一年',
      halfYear: '半年',
      month: '三个月'
    },

    pay: {
      pay1: '个人自付额',
      pay2: '家庭自付额'
    },
    pageTit: {
      BXCard: '保险卡',
      BXCardM: '保险卡管理',
      claimExplain: '理赔解释',

      hospitalSList: '就医记录',
      networkHospital: '网络医院',
      paymentDetail: '自助理赔详情',
      payment: '自助理赔材料补充',

      paymentDown1: '自助理赔服务指南',
      paymentDown2: '自助理赔单证',
      ownDetail: '自付额详情',
      ownQuery: '自付额进度查询',
      preDetail: '预授权详情',
      pre: '预授权材料补充',
      preQuery: '预授权进度查询',
      preDown1: '预授权服务指南',
      preDown2: '预授权单证',
      policyM: '保单管理',
      cardM: '选择保险卡',
      nowDynamic: '实时动态',
      nowDtit1: '公司活动',
      nowDtit2: '会员福利',
      idManager: '身份管理中心',
      IdentityCertifica: '身份认证',
      messageSettings: '消息推送设置',
      langSetting: '语言设置',
      message: '我的消息',
      addBXCard: '添加保险卡'
    },
    btn: {
      down1: '下载理赔单证',
      down2: '下载理赔服务指南',
      down3: '下载预授权单证',
      down4: '下载预授权服务指南'
    },
    AppointmentList: {
      title: '就诊预约'
    },
    AppointmentDetail: {
      title: '预约单详情',
      againtitle: '再次预约',
      eduittitle: '填写预约单'
    }
  },

  // mediLink
  btn: {
    setting: '设置',
    binding: '绑定',
    modify: '修改',
    submit: '提交',
    nextStep: '下一步',
    nextPage: '下一页',
    claimsExplain: '理赔解释',
    confirm: '确认',
    cancel: '取消',

    know: '知道了',
    unbind: '解除主领卡账号设置',
    btxt1: '您可对尾号为',
    btxt2: '的银行卡进行操作',
    del: '删除',
    setMain: '设置为主领卡账号',
    childAdd: '添加/查看 喜燕宝新生儿入保信息',

    back: '返回'
  },
  common: {
    save: '暂存',
    require: '-上传要求',
    sampleTip: '下图为示例说明，要求拍摄文字清晰',
    viewDetail: '查看详情',
    sickInfo: '病人信息',
    upload: '上传材料',
    done: '完成',
    note: '备注',
    notice: '理赔须知',
    writeApply: '填写申请',
    placeHolder1: '请输入您对预授权的其它诉求（125字）',
    placeHolder2: '请输入您对理赔的其它诉求（125字）',
    moneyHolder: '请填写金额',
    medicalHolder: '请输入医疗机构名称',
    applayerHolder: '请输入申请人',
    judgeHolder: '请输入诊断',
    seeDoctorHolder: '请选择就诊日期',
    seeDoctorHolder1: '请选择预计就诊日期',
    poliyDutyHolder: '请选择保险责任',
    poliyDutyHolder2: '请选择就诊类型',
    inHospitalTimeHolder: '请输入预估住院天数',
    medicalPayHolder: '请输入预估医疗费用',
    nameHolder: '请输入您的真实姓名',
    idNoHolder: '请输入本人有效证件号',
    bankNoHolder: '请输入本人银行卡号',
    bankDetailHolder: '请输入银行支行名称',
    bankB: '银行支行',
    bankRelationship: '请选择与保险卡关系',
    back: '返回',
    nodate: '暂无数据',
    add: '添加',
    cancleBtn: '取消',
    confirmBtn: '确认',
    supplementaryMaterials: '补充材料'
  },
  form: {
    chooseRelation: '请选择与出险人关系',
    // sickInfo.vue
    medicalInstitution: '医疗机构',
    policyNo: '保单号',
    insured: '被保险人',
    authCategory: '授权类别',
    preDoctorTime: '就诊日期',
    preDoctorTime1: '预计就诊日期',
    preDoctorTime2: '预计住院日期',
    judge: '诊断',
    inHospitalTime: '预估住院天数',
    medicalPay: '预估医疗费用',

    // suppleMaterialList.vue
    preAuthNo: '授权编号',
    policyNo_insured: '保单号/被保险人',
    //= 医疗机构
    //= 就诊日期
    //= 诊断
    needSupple: '需要补充',
    suppleDate: '补充材料',
    cancelApply: '撤销申请',

    // suppleMaterial.vue
    reviewProgress: '审核进度',
    reviewResult: '审核结论',
    failReason: '审核未通过原因',
    //= 补充材料

    // updateDate.vue
    update_text: '为了顺利通过审核 请提供以下材料',
    update_tip: '有圆点类别为必传项',
    // uploadComponent
    sample: '示例',
    update_text2: '包括化验清单、CT、B超、X光片、核磁等',

    // addBCard.vue form
    addCard: '添加银行卡',
    placeChooseCard:
      '请添加本人名下银行卡，请确保姓名、证件号码和银行卡号与银行预留信息完全一致',
    myName: '本人姓名',
    idNo: '证件号码',
    cardNo: '银行卡号',
    bankName: '银行名称',
    bankCity: '银行所在城市',
    bankHolder: '所属银行',
    cityHolder: '请选择省市',
    relationship: '与保险卡关系'
  },
  relationship: {
    relationship1: '本人',
    relationship2: '配偶',
    relationship3: '子女',
    relationship4: '父母'
  },
  bankCard: {
    // bankCard.vue
    text: '信用卡、存折、海外个人账户无法用于理赔的支付，请添加您的银行储蓄卡。',
    noCard: '您还没有添加银行卡',
    addCard: '添加银行卡',
    storeCard: '储蓄卡',
    openCardBK: '开户行', // 开户行
    bankaccnm: '户名'
  },
  bankCardExt: [
    '',
    '',
    '',
    '',
    '',
    '',
    '港币',
    '',
    '',
    '',
    '', // 10
    '',
    '',
    '',
    '美金',
    '英镑',
    '日元',
    '加元',
    '欧元',
    '新币',
    '泰铢', // 20
    '瑞士法郎',
    '丹麦克朗',
    '挪威克朗',
    '瑞典克朗',
    '南非兰特',
    '澳大利亚元',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    ''
  ],
  insureDuty: {
    head: '当审核中的理赔发生理赔调整时，会影响到界面...',
    wait: '等待期',
    paidStand: '赔付标准'
  },
  search: {
    search: '搜索',
    hotCity: '热门城市'
  },
  welfare: {
    // 暂不确定是否接口获取
    welPlan: '福利计划',
    policyList: '保险条款',
    listTxt1: '概况',
    listTxt2: '医疗机构限制',
    listTxt3: '事先授权说明',
    listTxt4: '责任免除说明',
    limit1: '终身限额（{0}）',
    limit2: '总年度限额（{0}）',
    area1: '保障区域',
    area2: '直付区域',
    planNo: '计划号',
    policySort: '保单币种类',
    elecPolicy: '电子保单',
    expireDate: '保单有效期',
    welfareDetail: '福利详情',
    otherPreExisting: '会员备注',
    times: '次',
    OPLimitAmt: '门诊就诊次数',
    OPLimitTimes: '门诊年限额',
    IPLimitAmt: '住院就诊次数',
    IPLimitTimes: '住院年限额'
  },
  list: {
    // preAuth,claimsBusiness中list
    preAuthApply: '预授权申请',
    preAuthApplySec: '请您关注保险条款中约定的授权条目',
    preAuthAdd: '预授权材料补充',
    preAuthAddSec: '对授权反馈问题进行补充上传',
    preAuthProSearch: '预授权进度查询',
    preAuthProSearchSec: '授权案件受理进度、历史记录状态查看',
    preAuthGuide: '预授权服务指南',
    preAuthGuideSec: '操作指引、应备材料，流程指引',
    preAuthBillDownload: '预授权单证下载',
    preAuthBillDownloadSec: '进行预授权申请时，相关单证下载',
    // claimsBusiness
    autoClaimApply: '自助理赔申请',
    autoClaimApplySec: '门诊医疗 住院医疗 住院补贴',
    claimMaterAdd: '理赔材料补充',
    claimMaterAddSec: '对理赔反馈问题进行补充上传',
    paidSearch: '待缴自付额查询',
    paidSearchSec: '对需要自己承担的费用进行缴纳',
    autoclaimProSearch: '自助理赔进度查询',
    autoclaimProSearchSec: '自助理赔案件受理进度、历史记录状态查看',
    claimServeGuide: '自助理赔服务指南',
    claimServeGuideSec: '操作指引、应备材料，流程指引',
    claimBillDownload: '自助理赔单证下载',
    claimBillDownloadSec: '进行索赔时，相关单证下载'
  },
  claimApply: {
    paidMoneyTips: '此金额仅供参考，实际缴纳金额以邮件或医院通知为准！',
    knowNotice: '提交申请前, 请您注意以下事项！',
    policyPeople: '出险人',
    effectInsureTime: '保险有效期',
    surrenderTime: '退保日期',
    applayer: '申请人',
    relationWithInsured: '与出险人关系',
    insureLiability: '保险责任',
    treatmentType: '就诊类型',
    applyMoney: '申请金额',
    moneyAccount: '汇款账户',
    claimAccount: '理赔款账户',
    submittedMaterial: '已提交材料',
    claimProgress: '理赔进度',
    suppleMaterial: '待补充理赔材料',
    claimMoney: '赔付金额',
    paidMoney: '自付金额',
    paidRemark: '付款标识',
    claimsResult: '理赔结论'
  },
  // mediLink
  toast: [
    '', // 0
    '',
    '',
    '' //
  ],
  wallet: ['', '', '', '', '', ''],
  noticeArr: [
    '', // 0
    `
    <p>诚信是保险合同基本原则，涉嫌保险诈骗将承担以下责任：</p>
    <p>【刑事责任】进行保险诈骗犯罪活动，可能会受到拘役、有期徒刑，并处罚金或没收财产的刑事处罚，保险事故的鉴定人、证明人故意提供虚假的证明文件，为他人犯罪提供条件的，以保险诈骗罪的共犯论处</p>
    <p>【行政责任】进行保险诈骗活动，尚不构成犯罪的，可能会受到15日以下的拘留、5000元以下罚款的行政处罚；保险事故的鉴定人、证明人故意提供虚假的证明文件，为他人诈骗提供条件的，也会受到相应行政处罚。</p>
    <p>【民事责任】故意或因重大过失未履行如实告知义务，保险公司不承担赔偿或给付保险金的责任</p>
    `,
    '', // 2
    `
    <p>我同意，在任何情况下，保险保障所不包含的医疗费用及服务等将由我本人足额支付。我同意由保险公司或者中间带直接联系我并通过银行转账的方式收取。如果我不能按时支付，我将承担由此产生的额外费用，包括合理的法律诉讼费用、保险公司、中间带或医疗机构向我收取此费用过程所产生的其他费用等。</p>
    <p>我同意因理赔或相关服务需要，保险公司、医疗机构及中间带可以分享与我本人有关的保险福利、健康、医疗信息及资料。我同意任何医生、医疗机构、药剂师、保险公司、雇主、工会或协会将我就诊治疗、接受护理的相关病历、病史等资料信息（包括复印件）提供给中间带。我同意因理赔或相关服务需要，由保险公司或者中间带代我处理理赔款。我在此确认以上声明和授权真实完整，我本人愿意进一步提供其他所需信息。</p>
    <p>对于发生在事先约定的医疗机构内，针对特定的或本保险人已经事先担保的医疗项目，本人在此授权该医疗机构或预先指定的第三方代表本人向保险人索赔，保险人应该直接支付给该医疗机构或指定的第三方。</p>
    <p>以上授权的复印件与原件视为同等效力。</p>
    `, // 3
    '',
    '', // 5
    '',
    '',
    '',
    '',
    '', // 10
    '',
    '',
    '',
    '',
    '', // 15
    '', // 16
    '', // 17
    '',
    '',
    '',
    '',
    '', // 22
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '', // 30
    '',
    '',
    ''
  ],
  cashierDesk: [
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '', // 15
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '', // 30
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '', // 40
    '',
    '',
    '请确认微信支付是否完成',
    '查询',
    '支付中，请支付完再尝试',
    ''
  ],
  extra: ['', '', '', '', ''],
  claimApplyText: ['选择保单', '填写申请'],
  survey: {
    submit: '提交问卷',
    search: '查看记录',
    questions: [
      '您对MediLink的总体满意度评价：',
      '您对MediLink的400服务热线评价为：',
      '您对MediLink的理赔服务评价为：',
      '您对MediLink的微信公众号服务平台的评价为：',
      '您对MediLink的直付医疗网络评价为：',
      '您会将MediLink推荐给您的朋友或者同事吗？',
      '您对MediLink有什么建议或意见？',
      '除了团体高端健康保险，您还知道MediLink提供其他产品和服务：',
      '您希望获得以下哪些健康服务？（多选题）'
    ], // 题目
    subQues: [
      [
        '接通率',
        '服务态度',
        '专业度（如对您所提问题的理解能力和解决问题能力）',
        '医院预约的反馈时效',
        '医院预约的成功率'
      ],
      ['总体评价', '时效和便捷性'],
      [
        '用户界面友好度',
        '系统稳定',
        '在线预约功能',
        '在线理赔功能',
        '医院查询功能',
        '支付自付金额功能',
        '资料下载（保险条款、福利表、服务手册等）功能',
        '电子卡显示'
      ],
      ['医院数量够用', '医疗机构服务水平', '驻院代表医院现场服务'],
      [
        '儿童高端医疗保险（新燕宝）',
        '个人高端医疗保险（臻荣耀）',
        '高端孕产险（喜燕宝）',
        '海外留学生保险'
      ]
    ],
    satisfaction: [
      '非常满意',
      '满意',
      '满意',
      '一般',
      '不满意',
      '不满意',
      '非常不满意',
      '不知道'
    ], // 满意度
    recommend: ['强烈推荐', '可能推荐', '不推荐'], // 推荐
    interested: ['感兴趣', '知道，不感兴趣', '不知道'],
    services: [
      '体检类，如报告解读、健康档案管理',
      '健康讲座/健康主题活动',
      '医疗服务，如专家推荐预约、科室推荐预约、多学科专家会诊预约',
      '儿科，如婴幼儿疫苗、眼科、儿童体检',
      '疫苗，如流感疫苗、HPV疫苗、带状疱疹疫苗',
      '慢性病管理及中医养生',
      '其他'
    ], // 感兴趣
    recommendReason: '您推荐或不推荐的最重要原因是？',
    errMsg: '请选择',
    success: '提交成功',
    successTip:
      '感谢您的支持，我们已收到您的反馈，我们将在10个工作日内发送奖品短信给您，谢谢！',
    overallMsg: '请填写完整问卷内容'
  }
}
